export const getDateDocCreated = (client) => {
	if (client?.documentInformation?.signatureRequests) {
		var sigReqObj = client?.documentInformation?.signatureRequests;

		var sigReqKeys = sigReqObj && Object.keys(sigReqObj);
		var timestamp = sigReqKeys[0] && sigReqObj[sigReqKeys[0]].timestamp;

		return timestamp;
	}
};
